import React from "react";

const posts = [
  { src: "/hero-slide.png", label: "Fresh coffee" },
  { src: "/slide-farmer.png", label: "Farm" },
  { src: "/Coffee2.jpg", label: "Customers" },
  { src: "/Coffee9.jpg", label: "Latte art" },
  { src: "/Coffee32.jpg", label: "Roastery" },
  { src: "/kbl-bag.png", label: "Packaging" },
];

const InstagramFeed = () => {
  return (
    <section className="bg-cream px-5 py-16 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
              Instagram
            </p>
            <h2 className="mt-2 font-display text-3xl text-espresso">@kbl.coffee</h2>
          </div>
          <a
            href="https://www.instagram.com/kbl.coffee/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-espresso underline-offset-4 hover:text-gold hover:underline"
          >
            Follow us
          </a>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {posts.map((post) => (
            <a
              key={post.label}
              href="https://www.instagram.com/kbl.coffee/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-xl"
            >
              <img
                src={post.src}
                alt={post.label}
                className="h-full w-full object-cover transition duration-500 group-hover:scale-110"
              />
              <span className="absolute inset-0 flex items-end bg-gradient-to-t from-espresso/60 to-transparent p-3 text-xs font-medium text-cream opacity-0 transition group-hover:opacity-100">
                {post.label}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
